module.exports = __webpack_public_path__ + "static/media/67.0ee70422.svg";